<div class="container-fluid text-center color-primario-fondo h-100">
    <div class="row justify-content-center">
        <div class="col-md-9 col-sm-12">
            <div class="card mt-5">
                <div class="card-header">
                    <h1>Página no encontrada</h1>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <img class="mt-5" src="assets/logotipos/universidad-surcolombiana-normal-vertical-b.png"
                                alt="universidad-surcolombiana-vertical-l.png">
                        </div>
                        <div class="col-sm-12">
                            <h5 class="my-5">Lo sentimos, la página que busca no fue encontrada.</h5>
                        </div>
                        <div class="col-sm-12">
                            <a class="btn btn-primary color-primario-fondo text-white mb-5"
                                [routerLink]="['/login']">Ir al inicio</a>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    CITCD
                </div>

            </div>

        </div>
    </div>
</div>